import React, { useEffect, useState } from "react";
import "./Style.css";
import Layout from "../../Components/Layout/Layout";
import TabsAiProfile from "../../Components/AiProfile/TabsAiProfile/Index";
import AiLeadsAction from "../../Components/AiLeads/AiLeadsButton/AiLeadsAction";
const AiProfile = () => {
  const [refState, setRefState] = React.useState(false);
  const [refStatenew, setRefStatenew] = React.useState(false);
  const [refStateShared, setRefStateShared] = React.useState(false);
  const [refStateSharednew, setRefStateSharednew] = React.useState(false);
  const [isDecisionMakerExcel, setIsDecisionMakerExcel] = React.useState(false);
  const [shareRecord, setShareRecord] = React.useState(false);
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);

  return (
    <>
      <Layout
        className={"paddingSet"}
        setRefState={setRefState}
        refStatenew={refStatenew}
        setRefStatenew={setRefStatenew}
        refState={refState}
        setRefStateShared={setRefStateShared}
        refStateSharednew={refStateSharednew}
        setRefStateSharednew={setRefStateSharednew}
        refStateShared={refStateShared}
      >
        <div className="child-section-of-everypage">
        <AiLeadsAction
          setIsDecisionMakerExcel={setIsDecisionMakerExcel}
          setShareRecord={setShareRecord}
        />
        <TabsAiProfile
          setRefStatenew={setRefStatenew}
          setRefState={setRefState}
          setRefStateShared={setRefStateShared}
          setRefStateSharednew={setRefStateSharednew}
          isDecisionMakerExcel={isDecisionMakerExcel}
          setIsDecisionMakerExcel={setIsDecisionMakerExcel}
          shareRecord={shareRecord}
          setShareRecord={setShareRecord}
        />
        </div>
      </Layout>
    </>
  );
};
export default AiProfile;
